import React, { useEffect, useState } from "react";
import axios from "../../utils/axiosConfig";

const UserRights = () => {

  const [userTypes, setUserTypes] = useState([]);
  const [selectedUserType, setSelectedUserType] = useState("");
  const [pages, setPages] = useState([]);

  useEffect(() => {
    loadUserTypes();
  }, []);

  const loadUserTypes = async () => {
    const res = await axios.get("/user-types");
    setUserTypes(res.data);
  };

  const loadRights = async (userTypeId) => {
    const res = await axios.get(`${"/user-rights"}/${userTypeId}`);
    setPages(res.data);
  };

  const handleUserTypeChange = (e) => {
    const id = e.target.value;
    setSelectedUserType(id);
    if (id) loadRights(id);
  };

  const handleCheckboxChange = (index, field) => {
    const updated = [...pages];
    updated[index][field] = !updated[index][field];
    setPages(updated);
  };

  const handleSave = async () => {
    try {
      await axios.post("/user-rights", {
        UserTypeID: selectedUserType,
        Rights: pages
      });

      alert("Rights saved successfully");
    } catch (err) {
      alert(err.response?.data?.message || "Error saving rights");
    }
  };

  return (
    <div className="container mt-3">

      {/* Page Title */}
      <div className="mb-3">
        <h4 className="fw-bold">User Rights</h4>
      </div>

      <div className="card shadow-sm border-0">

        <div className="card-body">

          {/* User Type Dropdown */}
          <div className="row mb-4">
            <div className="col-md-3">
              <label className="form-label fw-semibold">
                User Type
              </label>

              <select
                className="form-select"
                value={selectedUserType}
                onChange={handleUserTypeChange}
              >
                <option value="">Select User Type</option>
                {userTypes.map(u => (
                  <option key={u.UserTypeID} value={u.UserTypeID}>
                    {u.UserTypeName}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Rights Table */}
          {pages.length > 0 && (
            <table className="table table-bordered align-middle">
              <thead className="table-light">
                <tr>
                  <th>Page Name</th>
                  <th className="text-center">Read</th>
                  <th className="text-center">Add</th>
                  <th className="text-center">Edit</th>
                  <th className="text-center">Delete</th>
                </tr>
              </thead>

              <tbody>
                {pages.map((page, index) => (
                  <tr key={page.PageID}>
                    <td>{page.PageName}</td>

                    <td className="text-center">
                      <input
                        type="checkbox"
                        checked={page.CanRead}
                        onChange={() =>
                          handleCheckboxChange(index, "CanRead")
                        }
                      />
                    </td>

                    <td className="text-center">
                      <input
                        type="checkbox"
                        checked={page.CanAdd}
                        onChange={() =>
                          handleCheckboxChange(index, "CanAdd")
                        }
                      />
                    </td>

                    <td className="text-center">
                      <input
                        type="checkbox"
                        checked={page.CanEdit}
                        onChange={() =>
                          handleCheckboxChange(index, "CanEdit")
                        }
                      />
                    </td>

                    <td className="text-center">
                      <input
                        type="checkbox"
                        checked={page.CanDelete}
                        onChange={() =>
                          handleCheckboxChange(index, "CanDelete")
                        }
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}

          {/* Save Button */}
          {pages.length > 0 && (
            <div className="text-end mt-3">
              <button className="btn btn-success" onClick={handleSave}>
                Save
              </button>
            </div>
          )}

        </div>
      </div>
    </div>
  );
};

export default UserRights;
